module.exports = __webpack_public_path__ + "img/no2_ca.7bb85351.jpg";